import { request } from "../../services/base.service";
import store from "../index";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

const onRequest = () => {
  return store.dispatch({ type: FETCH_DATA_REQUEST });
};

const onSuccess = (data) => {
  return store.dispatch({ type: FETCH_DATA_SUCCESS, payload: data });
};

const onFailure = (error) => {
  store.dispatch({ type: FETCH_DATA_FAILURE, payload: error.response });
  const body = error?.response?.data;
  return {
    // 오류 본문(code/args/message)을 그대로 흘려보냅니다. 예전에는 버렸기 때문에
    // 백엔드가 실패 사유를 알려 줘도 화면은 기본 문구밖에 띄울 수 없었습니다.
    ...(body && typeof body === 'object' ? body : {}),
    // 호출부들이 response?.data 로 성공 여부를 가리므로 undefined 를 유지합니다.
    data: undefined,
  };
};

export const getData = async (endpoint) => {
  const { url, headers } = endpoint;
  // console.log("Request URL: ", url);
  onRequest();
  try {
    const response = await request.getRequestWithHeader(url, {
      headers: { ...headers },
    });
    // console.log("Response: ", response);
    onSuccess(response);
    return response;
  } catch (error) {
    console.error("action API Error: ", error);
    return onFailure(error);
  }
};

export const getPDFData = async (endpoint) => {
  const { url, headers, responseType } = endpoint;
  onRequest();
  
  try {
    const response = await request.getRequestWithHeader(url, {
      headers: { ...headers },
      responseType,
      maxRedirects: 0,
      validateStatus: function (status) {
        return status >= 200 && status < 400;
      }
    });
    
    onSuccess(response);
    return response;
  } catch (error) {
    console.error("action API Error: ", error);
    return onFailure(error);
  }
};

export const postData = async (endpoint, body) => {
  const { url, headers } = endpoint;
  onRequest();
  try {
    const response = await request.postRequestWithHeader(url, body, {
      headers: { ...headers },
    });
    // console.log("action response JSON: ", JSON.stringify(response, null, 2));
    onSuccess(response);
    return response;
  } catch (error) {
    console.error("Post data error["+error+"]");
    // return onFailure(error);
    return error;
  }
};

export const postGroupData = async (endpoint, body) => {
  const { url, headers } = endpoint;
  onRequest();
  try {
    // console.log("Sending request to:", url);
    // console.log("With headers:", headers);
    // console.log("With body:", JSON.stringify(body));
    
    const response = await request.postRequestWithHeader(url, body, {
      headers: { ...headers },
    });
    onSuccess(response);
    return response;
  } catch (error) {
    console.error("Post data error:", error);
    return error;
  }
};

export const loginPostData = async (endpoint, body) => {
  // console.log("loginPostData endpoint["+JSON.stringify(endpoint)+"]");
  const { url, headers } = endpoint;
  // const { url } = endpoint;
  onRequest();
  try {
    const response = await request.postRequestWithHeader(url, body, {
      headers: { ...headers },
      withCredentials: true  // 쿠키 전송을 허용
    });
    // console.log("API response status:", response.status);
    // console.log("API response headers:", response.headers);
    onSuccess(response);
    return response;
  } catch (error) {
    return onFailure(error);
  }
};

export const putData = async (endpoint, body) => {
  const { url, headers } = endpoint;
  onRequest();
  try {
    const response = await request.put(url, body, {
      headers: { ...headers },
    });
    onSuccess(response);
    return response;
  } catch (error) {
    return onFailure(error);
  }
};

export const deleteData = async (endpoint) => {
  const { url, headers } = endpoint;
  onRequest();
  try {
    const response = await request.delete(url, {
      headers: { ...headers },
    });
    onSuccess(response);
    return response;
  } catch (error) {
    return onFailure(error);
  }
};
